import { render } from "./consequence.vue?vue&type=template&id=2c8248aa&scoped=true"
import script from "./consequence.vue?vue&type=script&lang=js"
export * from "./consequence.vue?vue&type=script&lang=js"

import "./consequence.vue?vue&type=style&index=0&id=2c8248aa&lang=scss&scoped=true"
import "./consequence.vue?vue&type=style&index=1&id=2c8248aa&scoped=true&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8248aa"]])

export default __exports__